/**
 * Фоны области переписки в чате (модалка / ChatArea).
 * Пользователь выбирает пресет локально (localStorage); «по умолчанию» — градиент приложения или фото от админа.
 */

export const CHAT_THREAD_BG_STORAGE_KEY = 'chatThreadBackgroundPresetId';
/** Отдельный пресент градиента для пузырька сообщения (текст / имя / время подстраиваются). */
export const CHAT_MESSAGE_CARD_BG_STORAGE_KEY = 'chatMessageCardBackgroundPresetId';

/** Базовый градиент, если нет пресета и нет админского фото */
export const CHAT_THREAD_DEFAULT_GRADIENT =
  'linear-gradient(135deg, #232931 0%, #232b3a 100%)';

export const CHAT_THREAD_BACKGROUND_PRESETS = [
  // —— светлые (10) ——
  {
    id: 'ct-l1',
    label: 'Крем и персик',
    group: 'light',
    gradient: 'linear-gradient(145deg, #fff9f5 0%, #ffe8dc 45%, #ffd6c9 100%)',
  },
  {
    id: 'ct-l2',
    label: 'Мятный лёд',
    group: 'light',
    gradient: 'linear-gradient(130deg, #f0fdf9 0%, #d1fae5 50%, #a7f3d0 100%)',
  },
  {
    id: 'ct-l3',
    label: 'Небесная дымка',
    group: 'light',
    gradient: 'linear-gradient(135deg, #f8fbff 0%, #e0f2fe 40%, #dbeafe 100%)',
  },
  {
    id: 'ct-l4',
    label: 'Розовый кварц',
    group: 'light',
    gradient: 'linear-gradient(160deg, #fff5f7 0%, #fce7f3 45%, #fbcfe8 100%)',
  },
  {
    id: 'ct-l5',
    label: 'Лаванда',
    group: 'light',
    gradient: 'linear-gradient(135deg, #faf5ff 0%, #ede9fe 50%, #ddd6fe 100%)',
  },
  {
    id: 'ct-l6',
    label: 'Лимонный чай',
    group: 'light',
    gradient: 'linear-gradient(145deg, #fffbeb 0%, #fef3c7 50%, #fde68a 100%)',
  },
  {
    id: 'ct-l7',
    label: 'Морская пена',
    group: 'light',
    gradient: 'linear-gradient(125deg, #ecfeff 0%, #cffafe 45%, #a5f3fc 100%)',
  },
  {
    id: 'ct-l8',
    label: 'Слоновая кость',
    group: 'light',
    gradient: 'linear-gradient(180deg, #fafaf9 0%, #f5f5f4 50%, #e7e5e4 100%)',
  },
  {
    id: 'ct-l9',
    label: 'Весенний сад',
    group: 'light',
    gradient: 'linear-gradient(135deg, #f7fee7 0%, #ecfccb 40%, #d9f99d 100%)',
  },
  {
    id: 'ct-l10',
    label: 'Жемчужный',
    group: 'light',
    gradient: 'linear-gradient(160deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)',
  },
  // —— полутёмные (5) ——
  {
    id: 'ct-m1',
    label: 'Сумерки',
    group: 'mid',
    gradient: 'linear-gradient(145deg, #334155 0%, #1e293b 55%, #0f172a 100%)',
  },
  {
    id: 'ct-m2',
    label: 'Морская ночь',
    group: 'mid',
    gradient: 'linear-gradient(135deg, #1e3a5f 0%, #172554 50%, #0c1929 100%)',
  },
  {
    id: 'ct-m3',
    label: 'Лесная тень',
    group: 'mid',
    gradient: 'linear-gradient(130deg, #14532d 0%, #166534 45%, #0d1f17 100%)',
  },
  {
    id: 'ct-m4',
    label: 'Бордо',
    group: 'mid',
    gradient: 'linear-gradient(140deg, #3f1d2b 0%, #292524 40%, #1c1917 100%)',
  },
  {
    id: 'ct-m5',
    label: 'Индиго',
    group: 'mid',
    gradient: 'linear-gradient(135deg, #312e81 0%, #1e1b4b 50%, #172554 100%)',
  },
  // —— тёмные (5) ——
  {
    id: 'ct-d1',
    label: 'Глубокий уголь',
    group: 'dark',
    gradient: 'linear-gradient(165deg, #0a0a0b 0%, #18181b 50%, #27272a 100%)',
  },
  {
    id: 'ct-d2',
    label: 'Полночь',
    group: 'dark',
    gradient: 'linear-gradient(150deg, #020617 0%, #0f172a 55%, #1e293b 100%)',
  },
  {
    id: 'ct-d3',
    label: 'Чёрный океан',
    group: 'dark',
    gradient: 'linear-gradient(135deg, #020c1b 0%, #082f49 40%, #0c4a6e 100%)',
  },
  {
    id: 'ct-d4',
    label: 'Тёмный пурпур',
    group: 'dark',
    gradient: 'linear-gradient(140deg, #0f0518 0%, #1a0a2e 50%, #2d1b4e 100%)',
  },
  {
    id: 'ct-d5',
    label: 'Обсидиан',
    group: 'dark',
    gradient: 'linear-gradient(160deg, #000000 0%, #0c0c0e 45%, #18181b 100%)',
  },
];

const BY_ID = Object.fromEntries(CHAT_THREAD_BACKGROUND_PRESETS.map((p) => [p.id, p]));

export function getChatThreadBackgroundCss(id) {
  if (!id || typeof id !== 'string') return '';
  const p = BY_ID[id.trim()];
  return p ? p.gradient : '';
}

export function isValidChatThreadPresetId(id) {
  return typeof id === 'string' && !!BY_ID[id.trim()];
}

export function getChatThreadPresetStorageValue() {
  if (typeof localStorage === 'undefined') return '';
  return String(localStorage.getItem(CHAT_THREAD_BG_STORAGE_KEY) || '').trim();
}

/**
 * Тон иконок нижней панели мобильного чата: светлый пресет → тёмные иконки, иначе светлые.
 * «По умолчанию» (без пресета), полутёмные и тёмные пресеты → 'dark' (белые иконки).
 */
export function getChatThreadMobileToolbarTone() {
  const id = getChatThreadPresetStorageValue();
  if (!id) return 'dark';
  const p = BY_ID[id.trim()];
  if (!p) return 'dark';
  return p.group === 'light' ? 'light' : 'dark';
}

export function setChatThreadPresetStorageValue(presetId) {
  if (typeof localStorage === 'undefined') return;
  const v = presetId != null ? String(presetId).trim() : '';
  if (v) localStorage.setItem(CHAT_THREAD_BG_STORAGE_KEY, v);
  else localStorage.removeItem(CHAT_THREAD_BG_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent('chat-thread-user-preset-changed'));
}

export function getChatMessageCardPresetStorageValue() {
  if (typeof localStorage === 'undefined') return '';
  return String(localStorage.getItem(CHAT_MESSAGE_CARD_BG_STORAGE_KEY) || '').trim();
}

export function setChatMessageCardPresetStorageValue(presetId) {
  if (typeof localStorage === 'undefined') return;
  const v = presetId != null ? String(presetId).trim() : '';
  if (v) localStorage.setItem(CHAT_MESSAGE_CARD_BG_STORAGE_KEY, v);
  else localStorage.removeItem(CHAT_MESSAGE_CARD_BG_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent('chat-message-card-preset-changed'));
}

/** Для светлой карточки — тёмный текст; для полутёмной/тёмной — светлый. Без пресета карточки не используется. */
export function messageCardPresetUsesDarkText(presetId) {
  if (!presetId || typeof presetId !== 'string') return false;
  const p = BY_ID[presetId.trim()];
  if (!p) return false;
  return p.group === 'light';
}

export function resolveChatThreadImageUrl(path) {
  if (!path || typeof path !== 'string') return '';
  const t = path.trim();
  if (!t) return '';
  if (t.startsWith('http://') || t.startsWith('https://')) return t;
  if (t.startsWith('/uploads/')) {
    const g =
      (typeof window !== 'undefined' && (window.__API_ORIGIN__ || window.API_ORIGIN)) || '';
    const env =
      (typeof process !== 'undefined' &&
        process.env &&
        (process.env.REACT_APP_API_ORIGIN || process.env.VITE_API_ORIGIN)) ||
      '';
    const origin = g || env || (typeof window !== 'undefined' && window.location?.origin) || '';
    return `${origin}${t}`;
  }
  return t;
}
